import { post, upload } from '@/api/request'

export const uploadFile = async (formData: FormData, isStaticFile: boolean = true, onProgress?: (progress: { loaded: number; total: number; percent: number }) => void) => {
    return upload('/api/solve-x-ai/testprep/put-files-analyze-task?isStaticFile=' + (isStaticFile ? 1 : 0) + '&uploadTimeSpan=' + Date.now(), formData, {
        onUploadProgress: onProgress
    })
}

export const loadExamQT = (data: any) => {
    return post('/api/solve-x-ai/testprep/create-test-prep', data)
}

// 用户解答结果
export const submitTestResultType = {
    todo: 'U', // 未解答
    right: 'Y', // 正确
    wrong: 'N' // 错误
}

export const submitTestResult = (data: any) => {
    return post('/api/solve-x-ai/testprep/submit-test-prep-result', data)
}

export const duplicateTestPrep = (data: any) => {
    return post('/api/solve-x-ai/testprep/duplicate-test-prep', data)
}

export const getUserDemoQuestionList = () => {
    return post('/api/solve-x-ai/testprep/get-user-demo-question-list')
}

export const generateHome = () => {
    return post('/api/solve-x-ai/testprep/get-testprep-summary')
}

export const likeQuestion = (data: any) => {
    return post('/api/solve-x-ai/testprep/like-question', data)
}
